import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Template, TemplateItem } from '../template.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-template-info',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './template-info.component.html'
})
export class TemplateInfoComponent {

  @Input() template!: Template;

  isLoading: boolean = true;
  loadingText: string = 'Undersøger..';

  availItems: TemplateItem[] = [];
  createdFields: TemplateItem[] = [];
  updateFields: TemplateItem[] = [];
  readFields: TemplateItem[] = [];
  mandatoryFields: TemplateItem[] = [];
  deleteFields: TemplateItem[] = [];
  defaultFields: TemplateItem[] = [];
  keyFields: TemplateItem[] = []; 

  constructor(
    public activeModal: NgbActiveModal
  ) {}
    
  ngOnInit() {
      this.availItems = this.template.items.filter(x => x.synchronizeField);

      this.mandatoryFields = this.availItems.filter(z => z.mandatory);
      this.createdFields = this.availItems.filter(x => x.dbTableitemInfo && x.dbTableitemInfo.isCreateable);
      this.updateFields = this.availItems.filter(x => x.dbTableitemInfo && x.dbTableitemInfo.isUpdateable);      
      this.readFields = this.availItems.filter(x => x.dbTableitemInfo && x.dbTableitemInfo.isReadable);
      this.deleteFields = this.availItems.filter(x => x.dbTableitemInfo && x.dbTableitemInfo.isUpdateable);
      this.defaultFields = this.availItems.filter(x=> x.dbTableitemInfo && x.dbTableitemInfo.isCreateable  && x.dbTableitemInfo.isUpdateable && ! x.mandatory && ! x.dbTableitemInfo.isSystemfield && x.defaultValue != 'System: Null');
      this.keyFields = this.availItems.filter(x=> x.dbTableitemInfo && x.dbTableitemInfo.isKey);

      this.isLoading = false;
  }
}
